module.exports = "/assets/data/bf6bc636b28835f2c649ddf6a12de56f-OX3.data.json";